<template>
  <div>
    <div class="row mt-2 mb-4">
      <div class="d-none d-md-block col-md-2">
        <span class="i-account-profile-image-placeholder" style="width: 100%; height: 100%;"></span>
      </div>
      <div class="col-md-5">
        <p>{{$t('accounts.name')}}: <span class="is-bold">{{personName}}</span></p>
        <p>{{$t('clinical.people.birthday')}}: <span class="is-bold">{{person.birthdate | parseBirthdate}}</span></p>
        <p>{{$t('acconts.gender')}}: <span class="is-bold">{{$t(`genders.${person.gender.toLowerCase()}`)}}</span></p>
        <p>{{$t('people.inputs.phone')}}: <span class="is-bold">{{person.phone}}</span></p>
        <p>{{$t('people.inputs.mobile-phone')}}: <span class="is-bold">{{person.mobile_phone}}</span></p>
        <p>{{$t('accounts.email')}}: <span class="is-bold">{{person.email}}</span></p>
        <p>{{$t('clinical.people.address')}}: <span class="is-bold">{{personAddress}}</span></p>
      </div>
      <div class="col-md-5">
        <p>{{$t('clinical.people.client_nr')}}: <span class="is-bold">{{person.process_id}}</span></p>
        <p>{{$t('clinical.people.nif')}}: <span class="is-bold">{{person.tax_number}}</span></p>
        <p>{{$t('clinical.people.profession')}}: <span class="is-bold">{{person.profession}}</span></p>
        <p>{{$t('clinical.people.is_pensioner')}}: <span class="is-bold">{{ person.is_pensioner ? $t('clinical.people.anamnesis.common_options.yes') : $t('clinical.people.anamnesis.common_options.no') }}</span></p>
        <p>{{$t('clinical.people.is_deceased')}}: <span class="is-bold">{{ person.is_deceased ? $t('clinical.people.anamnesis.common_options.yes') : $t('clinical.people.anamnesis.common_options.no') }}</span></p>
        <p>{{$t('clinical.people.doctor')}}: <span class="is-bold">{{person.doctor}}</span></p>
        <p>{{$t('clinical.people.insurer')}}: <span class="is-bold">{{person.insurer}}</span></p>
        <p>{{$t('clinical.people.source')}}: <span class="is-bold">{{person.reference_id}}</span></p>
      </div>
      <div class="col-md-10 offset-md-2">
        <p>{{$t('clinical.people.obs')}}: <span class="is-bold">{{person.obs}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
import moment from 'moment'
export default {
  mixins: [
    CurrentLocaleMixin
  ],
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    personName: function () {
      return this.person.last_name ? `${this.person.first_name} ${this.person.last_name}` : this.person.first_name
    },
    personAddress: function () {
      let parsedAddress = ''
      if (this.person.addresses && this.person.addresses.length) {
        let address = this.person.addresses[0]
        let hasLine1 = address.line1 && address.line1 !== ''
        let hasLine2 = address.line2 && address.line2 !== ''
        let hasPostalCode = address.postal_code && address.postal_code !== ''
        let hasCity = address.city && address.city !== ''

        if (hasLine1) {
          parsedAddress += address.line1
          if ((hasLine2 || hasPostalCode || hasCity)) parsedAddress += ', '
        }
        if (hasLine2) {
          parsedAddress += address.line2
          if ((hasPostalCode || hasCity)) parsedAddress += ', '
        }
        if (hasPostalCode) {
          parsedAddress += address.postal_code
          if (hasCity) parsedAddress += ', '
        }
        if (hasCity) parsedAddress += address.city
      }
      return parsedAddress
    },
  },
  filters: {
    parseBirthdate: function (value) {
      if (!value || value === '') return ''
      let date = moment(value, 'YYYY-MM-DD HH:mm:ss')
      return date.isValid() ? date.format('DD/MM/YYYY') : ''
    }
  }
}
</script>
